import ReactLinkify from 'react-linkify';

export default function EntityDescription({ text }) {
  return (
    <ReactLinkify
      componentDecorator={(decoratedHref, decoratedText, key) => (
        <span className="decorated-link" key={key}>
          <a href={decoratedHref} target="_blank" rel="noopener noreferrer">
            {decoratedText}
          </a>
        </span>
      )}
    >
      <p // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: text,
        }}
        className="entity-description"
      />
    </ReactLinkify>
  );
}
